import React, {Component} from 'react'
import Playlist from './Playlist'
import '../styles/activity.css'
import {activityData} from '../microActivityData'

export default class Activity extends Component {
  constructor(props) {
    super(props)

    this.state = {
      module: this.props.module,
      activity: 0,
      answersPressed: [],
      correct: false,
      wrong: false,
    }

    this.onPressed = this.onPressed.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  onPressed = (e) => {
    const {value} = e.target
    let {answersPressed} = this.state

    let data = answersPressed.slice()
    const index = answersPressed.indexOf(Number(value))

    if (index === -1) {
      data.push(Number(value))
    } else {
      data.splice(index, 1)
    }
    this.setState({answersPressed: data})
  }
  onTryAgain = () => {
    this.setState({wrong: false, correct: false, answersPressed: []})
  }
  onContinue = () => {
    if (this.state.activity + 1 === activityData[this.state.module].length) {
      this.props.onEnd()
    } else {
      this.setState({
        correct: false,
        wrong: false,
        answersPressed: [],
        activity:
        this.state.activity + 1
      })
    }
  }
  onCompleted = () => {
    this.props.onEnd()
  }

  onSubmit = () => {
    let correct = activityData[this.state.module][this.state.activity].correct
    let {answersPressed} = this.state

    if (answersPressed.length === correct.length) {
      this.checkAnswersAreCorrect() ?
        this.setState({correct: true, wrong: false}) :
        this.setState({correct: false, wrong: true})
    } else {
      this.setState({wrong: true, correct: false})
    }
  }

  checkAnswersAreCorrect = () => {
    let correct = activityData[this.state.module][this.state.activity].correct
    let {answersPressed} = this.state
    let arr = []
    answersPressed.map(answer => {
      let found = correct.some(el => {
        return el.index === answer
      })
      if (found) {
        return arr.push(found)
      } else {
        return null
      }
    })
    return (arr.length === correct.length)
  }

  renderActivityViews = (data) => {
    return (
      <div>
        <img
          src={data.image}
          alt="" className="img-fluid"/>
        {this.state.correct && (
          <div className="card" style={{width: '22rem'}}>
            <div className="card-body">
              <h5 className="card-title">{data.continueText}</h5>
              <button className="btn btn-success" onClick={this.onContinue}>
                Continue
              </button>
            </div>
          </div>
        )}
        {this.state.wrong && (
          <div className="card" style={{width: '22rem'}}>
            <div className="card-body">
              <h5 className="card-title">{data.wrongText}</h5>
              <button className="btn submit" onClick={this.onTryAgain}>TRY
                AGAIN
              </button>
            </div>
          </div>
        )}

        <div className="activity-title-wrapper">
          <span className="activity-title"> {data.question} </span>
          <span className="activity-subtitle">{data.subtitle}</span>
        </div>
          {data.answers ? this.renderAnswerButtons(data) : this.renderCompletedButton()}
      </div>
    )
  }

  renderAnswerButtons = (data) => {
    let classes = this.props.index === 4 ? "btn submit green" : "btn submit";

    return (
      <div className="button-wrapper">
        {data.answers.map((ans, i) => (
          <button key={ans.index}
                  type="button"
                  className={this.state.answersPressed.includes(ans.index) ? 'btn btn-light answer active' : 'btn btn-light answer'}
                  value={ans.index}
                  onClick={this.onPressed}
          >
            {ans.answer}
          </button>
        ))}
        <button type="button" className={classes} onClick={this.onSubmit}>
          Submit
        </button>
      </div>
    )
  }

  renderCompletedButton = () => {
    return (
      <button className="btn btn-success complete-button"
              onClick={this.onCompleted}>
        CONTINUE
      </button>
    )
  }

  render() {
    let data = activityData[this.state.module][this.state.activity]

    return (
      <div className="player">
        <div className="video-outer">
          <div className="video-inner">
            <div className="wrapper">
              {this.renderActivityViews(data)}
            </div>
          </div>
        </div>
        {this.props.playlist &&
          <Playlist index={this.props.index} list={this.props.playlist}
                  onClickItem={this.props.onClickPlaylistItem}/>
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Activity.js